var map = {
	"./Canvas.vue": 2211,
	"./DocumentIframe.js": 706,
	"./Gallery.vue": 6643,
	"./ModeAndViewportToolbar.vue": 2580,
	"./ToolbarTop.vue": 3917,
	"./VersionActions.vue": 2714,
	"./tooltip.js": 5780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;